import { createAction, props } from '@ngrx/store';

export const goOutApp = createAction('[GlobalScope] go out App', props<{ goOutAppValue: boolean }>());
export const activeFastPlay = createAction('[GlobalScope] active Fast Play', props<{ activeFastPlayValue: boolean }>());
export const lastSearchField = createAction('[GlobalScope] set Last Search Field', props<{ lastSearchFieldValue: string }>());
export const setLoading = createAction('[GlobalScope] set is loading', props<{ isLoadingValue: boolean }>());
